import React from 'react';
import { Button, Spinner } from 'flowbite-react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { getSupportQuillModules } from './supportQuillConfig';

const TICKET_CREATE_QUILL_MODULES = getSupportQuillModules();

export const TICKET_CREATE_QUILL_CLASS =
    'bg-white dark:bg-gray-700 rounded-lg support-modal-quill [&_.ql-container]:h-[120px] [&_.ql-container]:min-h-[120px] [&_.ql-container]:overflow-y-auto [&_.ql-container]:resize-y [&_.ql-editor]:min-h-[118px]';

interface TicketCreateStepFormProps {
    value: string;
    onChange: (value: string) => void;
    onSend: () => void;
    isLoading: boolean;
    onBack: () => void;
    stripHtml: (html: string) => string;
}

const TicketCreateStepForm: React.FC<TicketCreateStepFormProps> = ({
    value,
    onChange,
    onSend,
    isLoading,
    onBack,
    stripHtml,
}) => (
    <div className="space-y-6 min-w-0">
        <button
            type="button"
            onClick={onBack}
            className="text-sm text-purple-600 dark:text-purple-400 hover:underline"
        >
            ← Back to questions
        </button>
        <p className="text-sm text-gray-600 dark:text-gray-400 rounded-lg bg-gray-50 dark:bg-gray-800 p-4 mb-2">
            Share the details of your issue so our support team can reach out with the right help.
        </p>
        <div className="support-fallback-quill min-w-0 mt-4">
            <ReactQuill
                theme="snow"
                value={value}
                onChange={onChange}
                placeholder="Type message here"
                modules={TICKET_CREATE_QUILL_MODULES}
                className={TICKET_CREATE_QUILL_CLASS}
            />
        </div>
        <div className="pt-2">
            <Button
                color="purplePlaced"
                onClick={onSend}
                disabled={!stripHtml(value).trim() || isLoading}
                className="w-full"
            >
                {isLoading ? (
                    <>
                        <Spinner size="sm" className="mr-2" />
                        Sending...
                    </>
                ) : (
                    'Send'
                )}
            </Button>
        </div>
    </div>
);

export default TicketCreateStepForm;
